'use client';

import Icon from '@/components/ui/AppIcon';

export default function ValuesSection() {
  const values = [
    {
      icon: 'StarIcon',
      title: 'Excellence',
      description: 'We maintain the highest standards in every aspect of our service, from apartment design to guest care, ensuring exceptional experiences every time.',
    },
    {
      icon: 'LightBulbIcon',
      title: 'Innovation',
      description: 'We continuously evolve our offerings, embracing new technologies and hospitality trends to provide modern, convenient solutions for our guests.',
    },
    {
      icon: 'HeartIcon',
      title: 'Genuine Care',
      description: 'Every guest is treated like family. We go beyond service to create meaningful connections and ensure your comfort and satisfaction.',
    },
    {
      icon: 'ShieldCheckIcon',
      title: 'Trust & Transparency',
      description: 'We build lasting relationships through honest communication, reliable service, and unwavering commitment to our promises.',
    },
    {
      icon: 'GlobeAltIcon',
      title: 'Sustainability',
      description: 'We are committed to environmentally responsible practices, from energy-efficient operations to supporting local communities.',
    },
    {
      icon: 'UserGroupIcon',
      title: 'Community',
      description: 'We actively engage with and contribute to the local Bangalore community, creating positive impact beyond our properties.',
    },
  ];

  return (
    <section className="py-20 bg-muted">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <div className="inline-flex items-center space-x-2 text-accent mb-4">
            <Icon name="SparklesIcon" size={24} />
            <span className="text-sm font-semibold uppercase tracking-wide">Our Values</span>
          </div>
          <h2 className="text-3xl lg:text-5xl font-display font-bold text-primary mb-6">
            What Drives Us Forward
          </h2>
          <p className="text-lg text-text-secondary">
            Our core values shape every decision we make and every interaction we have with our guests, partners, and community.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {values.map((value, index) => (
            <div
              key={index}
              className="bg-white rounded-xl p-8 shadow-subtle hover:shadow-premium transition-all duration-300 hover:-translate-y-1"
            >
              <div className="w-14 h-14 bg-gradient-to-br from-accent to-accent/80 rounded-lg flex items-center justify-center mb-6">
                <Icon name={value.icon as any} size={28} className="text-white" />
              </div>
              <h3 className="text-xl font-semibold text-primary mb-3">{value.title}</h3>
              <p className="text-text-secondary leading-relaxed">{value.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}